import { __require as r } from "./index.es137.js";
r();
//# sourceMappingURL=index.es34.js.map
